export const normalizePrompt = prompt => (prompt || '').trim()

export const mapPromptHistoryEntries = remoteEntries => {
  const seen = new Set()

  return remoteEntries
    .map(entry => {
      const prompt = normalizePrompt(entry.prompt)

      if (!prompt) {
        return null
      }

      return {
        id: entry.id,
        prompt
      }
    })
    .filter(Boolean)
    .filter(entry => {
      if (seen.has(entry.prompt)) {
        return false
      }

      seen.add(entry.prompt)

      return true
    })
}

export const prependPromptHistoryEntry = (entries, entry, limit = 10) => [
  entry,
  ...entries.filter(({ prompt }) => prompt !== entry.prompt)
].slice(0, limit)

export const removePromptHistoryEntryById = (entries, id) => (
  entries.filter(entry => entry.id !== id)
)
